import loadOneSignal from '../one-signal/one-signal-loader';
import initialize from '../one-signal/initialize';
import subscribe from '../app/composeable-subscribe';
import shouldSubscribe from '../utils/should-subscribe';

var push = function(id, options, oneSignalOptions){
    
    return loadOneSignal()
        .then(function(oneSignal){
            if (oneSignal.isPushNotificationsSupported()) {
                return initialize(oneSignal, id, oneSignalOptions);
            }
        })
        .then(function(oneSignal){
            return shouldSubscribe(oneSignal, options);
        })
//        .catch(function(reason){
//            console.log('caught after shouldSubscribe', reason);
//            return Promise.reject(reason);
//        })
        .then(function(oneSignal){
            return subscribe(oneSignal, options);
        })
        .catch(function(reason){
            console.log('caught debug from push.js', reason);
//            return Promise.reject(reason); // unclear if this needed and how
        });
}

export default push;


//////////////////
// WEBPACK FOOTER
// ./src/app/push.js
// module id = 2
// module chunks = 0